export const contactPositionOptions = [
  { name: 'Owner', id: 1, reference: 'owner' },
  { name: 'Management', id: 2, reference: 'management' },
  { name: 'Sales', id: 3, reference: 'sales' },
  { name: 'Technical', id: 4, reference: 'technical' },
  { name: 'Accounts', id: 5, reference: 'accounts' },
  { name: 'Administration', id: 6, reference: 'administration' },
];
